import React, { CSSProperties, FC, useCallback } from 'react'

import { XMarkIcon } from '@heroicons/react/24/outline'
import ReactDOM from 'react-dom'

interface ModalProps {
  visible: boolean
  toggle: VoidFunction
  children?: React.ReactNode
  onClose?: VoidFunction
  containerSelector?: string
  title?: string
  showCloseButton?: boolean
  modalCSS?: CSSProperties
  overlayCSS?: string
}

const Modal: FC<ModalProps> = ({
  visible,
  toggle,
  children,
  onClose,
  containerSelector = 'body',
  title = '',
  showCloseButton = true,
  modalCSS = {},
  overlayCSS = '',
}) => {
  const handleClose = useCallback(() => {
    typeof onClose === 'function' && onClose()
    toggle()
  }, [onClose, toggle])

  if (!visible) return null

  return ReactDOM.createPortal(
    <section
      className='top-0 left-0 fixed w-screen h-screen bg-slate-700/60 z-50 flex justify-center items-center'
      role='dialog'
      aria-modal='true'
    >
      <div
        className='bg-white shadow fixed z-20 rounded-md'
        style={modalCSS}
      >
        <header className='flex items-center justify-between mb-2 pb-2 border-b text-[14px] font-semibold bg-[#cfdfef] rounded-t-md p-3'>
          <span>{title}</span>
          {showCloseButton && (
            <button
              type='button'
              data-modal-close
              onClick={handleClose}
            >
              <XMarkIcon width={20} />
            </button>
          )}
        </header>
        <main className='p-3'>{children}</main>
      </div>
      <div
        className={`absolute top-0 left-0 right-0 bottom-0 bg-gray-400 opacity-40 z-10 cursor-pointer ${overlayCSS}`}
        onClick={handleClose}
      ></div>
    </section>,
    document.querySelector(containerSelector) ?? document.body
  )
}

export default Modal
